/* eslint-disable no-console */
import zukeeper from 'zukeeper';
import {create} from 'zustand';

interface dataStore {
  activityPerformance: any;
  setActivityPerformance: (activityPerformance: any) => void;
  chatStore: any[];
  setChatStore: (newChat: any) => void;
}

const useDataStore = create<dataStore>(
  zukeeper((set: any) => ({
    activityPerformance: {},
    setActivityPerformance: (activityPerformance: any) => {
      set(() => ({activityPerformance}));
    },
    chatStore: [],
    setChatStore: (newChat: any) => {
      set((state: any) => ({chatStore: [...state.chatStore, newChat]}));
    }
  }))
);

(window as any).store = useDataStore;

export default useDataStore;
